import React from "react";
import classnames from "classnames";
import styles from "./input.module.scss";

interface InputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  className?: string;
}

const Input: React.FC<InputProps> = ({ className = "", ...props }) => (
  <input className={classnames(styles.input, className)} {...props} />
);

export default Input;
